const platform = process.env.NODE_ENV;

// Docker sets this to an empty string so the browser requests /api. The React
// development server proxies that request to http://api:4000 inside Docker.
export const baseUrl =
  process.env.REACT_APP_API_URL ??
  (platform === "development"
    ? "http://localhost:4000"
    : "https://switchfund.onrender.com");
